// import React from 'react'

// const Rejected = () => {
//   return (
//     <div>Rejected</div>
//   )
// }

// export default Rejected

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  LogoLoader,
  Modal,
  NewTable,
  StatusTags,
} from "../../../../components";
import { allBillsrowdata } from "../../../../assets/data/candidatesData";
import { dateFormator, mapTableRows } from "../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { getAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../hooks";
import { Link, useNavigate } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";
import { status } from "../../../../assets/data/projectData";
import { formatCurrency } from "../../../../utils/stringUtils";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const Rejected = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables,
  );

  const { value } = useSelector((state) => state.totalCount);

  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  //const tablerowData = accountPayables;
  const tablerowData = accountPayables?.data || []; // Add null check with default empty array

  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const AllbillsColumns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1">
          {/* <Link
            to={`/accounts-payable/edit/${row.uiid}`}
            state={{ code: row.uiid, edit: true }}
          > */}
          <span
            className="text-linkblue"
            onClick={() => setSelectedInvoice(row?.uiid)}
          >
            {row.invoiceNum}
          </span>
          {/* </Link> */}
        </div>
      ),
      //sortfun: () => handleSort("invoiceNum"),
    },
    {
      key: "employeeId",
      label: "Employees",
      render: (row) => {
        return (
          <div>
            {row.employeeId.map((item, index) => (
              <span key={index}>
                {[item.firstName, item.lastName].filter(Boolean).join(" ")}
                {index < row.employeeId.length - 1 && ", "}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      key: "vendorId",
      label: "Vendor",
      render: (row) => {
        return <div>{row.vendorId.businessName || "-"}</div>;
      },
      sortfun: () => handleSort("vendorId.businessName"),
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      render: (row) => {
        return <div>{getVendorId(row.vendorId.uiid)}</div>;
      },
      sortfun: () => handleSort("vendorId"),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
      sortfun: () => handleSort("billedAmount"),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "modifiedOn",
      label: "Modified On",
      render: (row) => dateFormator(row.modifiedOn, "month-day-year"),
    },
    {
      key: "Is Modified",
      label: "IsModified",
      render: (row) =>
        row.isModify ? <StatusTags tag={"Yes"} /> : <StatusTags tag={"No"} />,
    },
    {
      key: "Actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => navigate(`/accounts-payable/edit/${row.uiid}`)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tablerowData, AllbillsColumns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          status: {
            type: "NONE",
            value: 4,
          },
        },
        // ret: "uiid invoiceNum employeeId vendorId invoiceDate dueDate amounts addedOn modifiedOn isModified",
        ref: "Employee Vendor",
        incl: ["firstName lastName", "businessName"],
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    dispatch(
      totalCountStart({
        filters: {
          status: {
            type: "NONE",
            value: 4,
          },
        },
        collection: "accountpayables",
        coll: "AccountPayable",
        //filters: item.filters,
      }),
    );
  }, [dispatch, page, limit, sortConfig]); // Empty array will cause it to run once when the component mounts

  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <NewTable
        showCheckbox
        columns={AllbillsColumns}
        rows={mappedRows}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default Rejected;
